import { render, staticRenderFns } from "./MonthlyTaxPaye.vue?vue&type=template&id=7a08c126"
import script from "./MonthlyTaxPaye.vue?vue&type=script&lang=js"
export * from "./MonthlyTaxPaye.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports